var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"desktop"}},[_vm._v(" this is desktop ")])
}
var staticRenderFns = []

export { render, staticRenderFns }